import { ISystemParameter } from '@/shared/model/system-parameter.model';
import { IUser } from '@/shared/model/user.model';
import { Module } from 'vuex';

export interface AccountStateStorable {
  logon: boolean;
  userIdentity: null | IUser;
  authenticated: boolean;
  ribbonOnProfiles: string;
  activeProfiles: string;
  systemParameter: null | ISystemParameter;
}

export const defaultAccountState: AccountStateStorable = {
  logon: false,
  userIdentity: null,
  authenticated: false,
  ribbonOnProfiles: '',
  activeProfiles: '',
  systemParameter: null,
};

export const accountStore: Module<AccountStateStorable, any> = {
  state: { ...defaultAccountState },
  getters: {
    logon: state => state.logon,
    account: state => state.userIdentity,
    authenticated: state => state.authenticated,
    activeProfiles: state => state.activeProfiles,
    ribbonOnProfiles: state => state.ribbonOnProfiles,
    systemParameter: state => state.systemParameter,
  },
  mutations: {
    authenticate(state) {
      state.logon = true;
    },
    authenticated(state, identity) {
      state.userIdentity = identity;
      state.authenticated = true;
      state.logon = true;
    },
    logout(state) {
      state.userIdentity = null;
      state.authenticated = false;
      state.logon = false;
    },
    setActiveProfiles(state, profile) {
      state.activeProfiles = profile;
    },
    setRibbonOnProfiles(state, ribbon) {
      state.ribbonOnProfiles = ribbon;
    },
    setSystemParameter(state, view) {
      state.systemParameter = view;
    },
  },
};
